import React from "react";
import { CheckIcon } from "../icons";

interface ValidatedTextareaProps {
  label: string;
  name: string;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: () => void;
  required?: boolean;
  rows?: number;
  maxLength?: number;
  className?: string;
}

const ValidatedTextarea: React.FC<ValidatedTextareaProps> = ({
  label,
  name,
  placeholder,
  value,
  onChange,
  onBlur,
  required = false,
  rows = 4,
  maxLength = 2000,
  className = "",
}) => {
  const isValid = value && value.trim();

  return (
    <div className={`space-y-2 ${className}`}>
      <label htmlFor={name} className="form-label">
        {label} {required && <span className="text-error-500">*</span>}
      </label>
      <div className="relative">
        <textarea
          name={name}
          id={name}
          rows={rows}
          className={`form-input resize-none ${isValid ? "form-input-valid" : ""}`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          maxLength={maxLength}
        />
        {isValid && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3 text-success-500">
            <CheckIcon />
          </div>
        )}
      </div>
      <div className="text-xs text-neutral-500">
        {value ? `${value.length}/${maxLength}` : `0/${maxLength}`} znaków
      </div>
    </div>
  );
};

export default ValidatedTextarea;
